import React from "react";
import HeroVideo from "../components/HeroVideo";
import ProductSection from "../components/ProductSection";
import ArticleBlocks from "../components/ArticleBlocks";
import RegisterBox from "../components/RegisterBox";
import Footer from "../components/Footer";
import "./Home.css";

const Home = () => {
  return (
    <div className="home">
      <HeroVideo />
      <ArticleBlocks />
      <ProductSection />
      <RegisterBox />
      <Footer />
    </div>
  );
};

export default Home;
